<template>
  <div>
    <!-- Year Selector -->
    <v-row class="mt-4">
      <v-col cols="12">
        <div class="d-flex align-center ga-1">
          <div style="font-size: 30px; font-weight: 700">Overview</div>
          <div class="mx-2" style="background-color: #c9d6f2; height: 30px; width: 2px"></div>
          <span style="font-size: 18px" class="font-weight-medium mr-2">Years</span>
          <YearPicker :model-value="selectedYears" :available-years="availableYears" :display="yearPickerDisplay" @toggle="toggleYear" @clear="clearYears" @select-all="selectAllYears" />
        </div>
      </v-col>
    </v-row>

    <!-- Pie Charts (when <= 3 years selected) -->
    <v-row v-if="selectedYears.length > 0 && selectedYears.length <= 3" class="mt-4">
      <v-col v-for="year in sortedSelectedYears" :key="year" :cols="12 / sortedSelectedYears.length">
        <v-card class="pa-4" style="border-radius: 12px">
          <div class="d-flex align-center mb-3">
            <v-icon class="mr-2" color="primary" size="small">mdi-chart-donut</v-icon>
            <span style="font-size: 16px; font-weight: 700">{{ year }}</span>
          </div>
          <PieChart v-if="yearlyData[year]" :data="toPieData(yearlyData[year])" :title="year + ' Distribution'" :horizontal="false" :show-export="false" />
          <div v-else class="d-flex align-center justify-center" style="min-height: 200px">
            <span class="text-body-2 text-medium-emphasis">No data for {{ year }}</span>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Time Series Chart (when > 3 years selected) -->
    <v-row v-if="selectedYears.length > 3" class="mt-4">
      <v-col cols="12">
        <YearlyTrendChart :series="trendSeries" :chart-options="trendChartOptions" />
      </v-col>
    </v-row>

    <!-- Spec Comparison Table (when >= 2 years selected) -->
    <v-row v-if="selectedYears.length >= 2" class="mt-4">
      <v-col cols="12">
        <YearlyComparisonTable :years="sortedSelectedYears" :comparison-rows="comparisonRows" :best-year-idx="bestYearIdx" :verdict-text="verdictText" :format-number="formatNumber" />
      </v-col>
    </v-row>

    <!-- Empty state -->
    <v-row v-if="selectedYears.length === 0" class="mt-4">
      <v-col cols="12">
        <v-card class="pa-8 d-flex flex-column align-center justify-center" style="border-radius: 12px; min-height: 300px">
          <v-icon size="64" color="grey-lighten-1">mdi-calendar-search</v-icon>
          <div class="text-body-1 mt-3 text-medium-emphasis">Select years above to view data</div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PieChart from '@/components/TaxDashboard/PieChart.vue';
import YearPicker from '@/components/TaxDashboard/YearPicker.vue';
import YearlyTrendChart from '@/components/TaxDashboard/YearlyTrendChart.vue';
import YearlyComparisonTable from '@/components/TaxDashboard/YearlyComparisonTable.vue';

import { useYearlyData } from '@/composables/TaxDashboard/useYearlyData';
import { useYearlyCharts } from '@/composables/TaxDashboard/useYearlyCharts';
import { useYearlyComparison } from '@/composables/TaxDashboard/useYearlyComparison';

export default {
  name: 'YearToDateTab',
  components: {
    PieChart,
    YearPicker,
    YearlyTrendChart,
    YearlyComparisonTable,
  },
  setup() {
    const { yearlyData, availableYears, yearPickerDisplay, selectedYears, sortedSelectedYears, toggleYear, clearYears, selectAllYears, toPieData, formatNumber } = useYearlyData();

    const { trendSeries, trendChartOptions } = useYearlyCharts(yearlyData, sortedSelectedYears);

    const { comparisonRows, bestYearIdx, verdictText } = useYearlyComparison(yearlyData, sortedSelectedYears);

    return {
      yearlyData,
      availableYears,
      yearPickerDisplay,
      selectedYears,
      sortedSelectedYears,
      toggleYear,
      clearYears,
      selectAllYears,
      toPieData,
      formatNumber,
      trendSeries,
      trendChartOptions,
      comparisonRows,
      bestYearIdx,
      verdictText,
    };
  },
};
</script>
